import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import Loading from '@components/Loading';
import Chart from '@components/charts/Chart';
import { apiGetDevicesInformation } from '@services/ManageDevices/DeviceServices';
import { showError } from '@components/notification';
import { formatCurrency } from '@utils/utils';
import OnOffImage from '@assets/images/on-off.png';
import NbIOTImage from '@assets/images/nb-iot.png';

const DeviceStatusCharts = () => {
  const [loading, setLoading] = useState(false);
  const [countDetail, setCountDetail] = useState(null);

  const handleChartClick = (status) => {
    // Scroll to list component
    const listElement = document.getElementById('device-list-table');
    if (listElement) {
      listElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Set filter status using event
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('filterDeviceStatus', { detail: { status } }));
    }, 500);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiGetDevicesInformation({
        page: 1,
        size: 10
      });
      setCountDetail(res.data?.meta?.countDetail);
    } catch (error) {
      console.error('Error fetching device statistics:', error);
      showError('Không thể tải thống kê thiết bị');
      setCountDetail(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // Auto refresh every 30 seconds
    // const interval = setInterval(fetchData, 30000);
    // return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div
        className="loading-container"
        style={{
          height: '250px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Loading />
      </div>
    );
  }

  return (
    <div>
      <Row gutter={[16, 16]}>
        {/* Online/Offline Donut Chart */}
        <Col md={12} xs={24}>
          <div style={{ textAlign: 'center', width: '100%' }}>
            <div style={{ position: 'relative' }}>
              <Chart
                options={{
                  colors: ['#52c41a', '#dc3545'],
                  labels: [
                    `Online: ${countDetail?.total_online || 0}`,
                    `Offline: ${countDetail?.total_offline || 0}`
                  ],
                  legend: {
                    position: 'bottom'
                  },
                  tooltip: {
                    y: {
                      formatter: (val) => `${formatCurrency(val)}`
                    }
                  },
                  chart: {
                    events: {
                      dataPointSelection: (event, chartContext, config) => {
                        const clickedIndex = config?.dataPointIndex;
                        if (clickedIndex === 0) {
                          handleChartClick('online');
                        } else if (clickedIndex === 1) {
                          handleChartClick('offline');
                        }
                      }
                    }
                  }
                }}
                series={[
                  Number(countDetail?.total_online || 0),
                  Number(countDetail?.total_offline || 0)
                ]}
                height={180}
                type="donut"
              />
              <img
                src={OnOffImage}
                alt="Online Offline"
                style={{
                  position: 'absolute',
                  top: '42%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '60px',
                  height: '60px'
                }}
              />
            </div>
          </div>
        </Col>

        {/* NB-IOT RSRP Signal Strength Donut Chart */}
        <Col md={12} xs={24}>
          <div style={{ textAlign: 'center', width: '100%' }}>
            <div style={{ position: 'relative' }}>
              <Chart
                options={{
                  colors: ['#28a745', '#ffc107', '#dc3545'],
                  labels: [
                    `Tốt: ${countDetail?.rsrp_strong || 0}`,
                    `Trung bình: ${countDetail?.rsrp_normal || 0}`,
                    `Yếu: ${countDetail?.rsrp_low || 0}`
                  ],
                  legend: {
                    position: 'bottom'
                  },
                  chart: {
                    events: {
                      dataPointSelection: (event, chartContext, config) => {
                        const clickedIndex = config?.dataPointIndex;
                        if (clickedIndex === 0) {
                          handleChartClick('RSRP_STRONG');
                        } else if (clickedIndex === 1) {
                          handleChartClick('RSRP_NORMAL');
                        } else if (clickedIndex === 2) {
                          handleChartClick('RSRP_LOW');
                        }
                      }
                    }
                  }
                }}
                series={[
                  Number(countDetail?.rsrp_strong || 0),
                  Number(countDetail?.rsrp_normal || 0),
                  Number(countDetail?.rsrp_low || 0)
                ]}
                height={180}
                type="donut"
              />
              <img
                src={NbIOTImage}
                alt="NB-IOT"
                style={{
                  position: 'absolute',
                  top: '42%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '55px',
                  height: '44px'
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DeviceStatusCharts;
